import { useTranslation } from 'react-i18next';
import { BulkUploadDocument } from '@steelbuy/data-access';
import { ButtonTertiaryOnLightM, getFileSize, InputRadioButton, LoadingStatus } from '@steelbuy/ui-primitive';

export const BulkListingPreviousFiles = ({
    files,
    onChange,
    selectedDocumentId,
    totalFiles,
    fetchNextPage,
    isFetchingNextPage,
    hasNextPage,
    label,
}: {
    files?: BulkUploadDocument[];
    onChange: (documentId: string) => void;
    selectedDocumentId?: string;
    totalFiles?: number;
    fetchNextPage: () => void;
    isFetchingNextPage: boolean;
    hasNextPage?: boolean;
    label?: string;
}) => {
    const { t } = useTranslation(['uiDomain']);

    if (!files?.length) {
        return null;
    }

    return (
        <div>
            {label && <div className="input-previous-files__label">{label}</div>}
            <div className="input-previous-files__files">
                {files?.map((file, i) => (
                    <div
                        key={file.documentId}
                        style={{
                            gridColumn: i % 2 === 0 ? '1' : '2',
                            gridRow: Math.floor(i / 2) + 1,
                        }}
                    >
                        <InputRadioButton
                            labelElement={
                                <div className="input-previous-files__files__file-info">
                                    <span>{file.fileName}</span>
                                    <span>{getFileSize(file.size, t)}</span>
                                </div>
                            }
                            onChange={() => {
                                onChange(file.documentId);
                            }}
                            checked={file.documentId === selectedDocumentId}
                        />
                    </div>
                ))}
            </div>
            {totalFiles && totalFiles > 10 ? (
                <div className="input-previous-files__load-more">
                    <ButtonTertiaryOnLightM
                        onClick={() => fetchNextPage()}
                        label={t('uiDomain:commonList.loadMore')}
                        loadingStatus={isFetchingNextPage ? LoadingStatus.PENDING : LoadingStatus.IDLE}
                        disabled={!hasNextPage}
                    />
                </div>
            ) : null}
        </div>
    );
};
